import { createSelector } from '@ngrx/store';
import { contractConfirmationFeature } from './contract-confirmation.reducer';

export const selectOpenMicarContracts = createSelector(contractConfirmationFeature.selectContractConfirmations, (contractConfirmations) => {
  const micarContracts = contractConfirmations.filter(({ documentKey }) => documentKey?.includes('micar'));
  return micarContracts?.length ? micarContracts : null;
});

export const selectDisplayNudgingNotification = createSelector(
  selectOpenMicarContracts,
  (contracts) => contracts?.length && new Date() >= new Date('2025-02-17'),
);
